const copy = {
  brand: "Vitalis",
  longName: "Vitalis Marketing Studio",
  domain: "vitalisrs.com",
  positioning:
    "The local-market partner for international brands entering Türkiye — digital, social, retail and PR under one roof.",
  blurb:
    "Vitalis is a Belgrade-based marketing studio that helps international brands launch and grow in Türkiye. We design the market-entry plan, run the digital and performance media, build the social and creator presence, activate retail and e-commerce, and operate the local customer experience — under one accountable team, in Türkçe and English.",
  contact: {
    email: "info@vitalisrs.com",
    response: "Replies within one business day, in English or Türkçe."
  },
  hq: {
    city: "Belgrade",
    country: "Serbia",
    region: "Savski Venac",
    address: {
      line1: "33 Luke Čelovića Trebinjca Street",
      line2: "Savski Venac, 11000 Belgrade",
      country: "Serbia"
    }
  },
  metrics: [
    { value: "40+", label: "International brands launched in Türkiye", note: "FMCG · fashion · tech · automotive · F&B · hospitality" },
    { value: "12", label: "Sectors actively covered" },
    { value: "100%", label: "TR-native bilingual team" },
    { value: "24 / 7", label: "Always-on social listening & community" }
  ],
  // Industries we serve — renamed from "markets" internally; keeps the route key for the data layer.
  markets: [
    { region: "FMCG & Consumer Goods", hubs: "Household · personal care · staples" },
    { region: "Fashion & Luxury", hubs: "Apparel · accessories · footwear · jewellery" },
    { region: "Beauty & Cosmetics", hubs: "Skincare · colour · fragrance · derma" },
    { region: "Food & Beverage", hubs: "Specialty foods · beverages · supplements" },
    { region: "Technology & SaaS", hubs: "Consumer apps · B2B SaaS · hardware" },
    { region: "Travel & Hospitality", hubs: "Hotel groups · OTAs · tourism boards" },
    { region: "Automotive & Mobility", hubs: "OEMs · EVs · two-wheelers · accessories" },
    { region: "Health & Wellness", hubs: "OTC · medical devices · fitness · clinics" },
    { region: "Home & Lifestyle", hubs: "Furniture · decor · appliances · pet" }
  ],
  clients: [
    "International consumer brands entering Türkiye for the first time",
    "Regional brand teams scaling an existing TR launch",
    "Direct-to-consumer brands building a Turkish presence",
    "B2B and SaaS companies opening a Turkish go-to-market",
    "Hotel groups, OTAs and tourism boards targeting Turkish travellers",
    "Distributors and importers responsible for foreign brand portfolios"
  ]
};

export default copy;
